import type { RemindKind, ToldDto, ToldPersonDto } from '@nsb/core';
import { useState } from 'react';
import { useApi } from '../api.ts';
import { easternToday } from '../days.ts';
import { remindState } from './remindWords.ts';

/** What was told of one thing waiting on the client, for one place on NSB's page (design study 26; Remind.tsx). */
export interface Remind {
  kind: RemindKind;
  subjectId: string;
  /** Who it waits on, as this place shows them: one reviewer on their row, else everyone. */
  people: ToldPersonDto[];
  today: string;
  /** Someone can be reminded now; else reminded today, again tomorrow; else nothing to offer. */
  state: 'can' | 'today' | null;
  open: boolean;
  setOpen: (open: boolean) => void;
  projectId: string;
  contactId: string | null;
}

/** What was told of one thing on NSB's own page; `staff` false reads nothing, so a client never asks. */
export function useRemind(projectId: string, kind: RemindKind, subjectId: string | null, opts: { staff: boolean; contactId?: string | null }): Remind {
  const { data } = useApi<ToldDto[]>(['project', projectId, 'told'], opts.staff && subjectId ? `/projects/${projectId}/told` : null);
  const [open, setOpen] = useState(false);
  const item = data?.find((i) => i.kind === kind && i.subjectId === subjectId) ?? null;
  const contactId = opts.contactId ?? null;
  const people = item ? (contactId ? item.people.filter((p) => p.contactId === contactId) : item.people) : [];
  const today = easternToday();
  return { kind, subjectId: subjectId ?? '', people, today, state: remindState(people, today), open, setOpen, projectId, contactId };
}
